module.exports = __webpack_public_path__ + "static/img/1.1382a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.png
// module id = W23E
// module chunks = 1